<script>
  import GradientBackground from "./GradientBackground.svelte";
  import AccordionItem from "./AccordionItem.svelte";
  import { fade, fly } from "svelte/transition";

  export let groupData = [];
  export let groupName = "";
  export let groupColor = "";
  export let groupGradient = "";

  let isOpen = false;

  const handleOpen = (e) => {
    isOpen = e.detail.isOpen;
  };
</script>

<AccordionItem
  title={groupName}
  bgColor={groupColor}
  bgGradient={groupGradient}
  on:isOpen={handleOpen}
>
  {#if isOpen}
    <div transition:fly class="row-container panel">
      {#each groupData as gd}
        <GradientBackground gradientStyle={gd} />
      {/each}
    </div>
  {/if}
</AccordionItem>

<styel />
